const SUPABASE_URL = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const SUPABASE_ANON_KEY = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;
const EDGE_BASE = `${SUPABASE_URL}/functions/v1`;

export async function invokeAdmin<T>(
  body: Record<string, unknown>
): Promise<{ data: T | null; error: string | null }> {
  try {
    const res = await fetch(`${EDGE_BASE}/villa-admin`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
      },
      body: JSON.stringify(body),
    });
    const responseText = await res.text();
    let parsed: unknown;
    try {
      parsed = JSON.parse(responseText);
    } catch {
      parsed = responseText;
    }
    if (!res.ok) {
      const msg =
        (parsed as Record<string, string>)?.message ||
        (parsed as Record<string, string>)?.error ||
        responseText ||
        `HTTP ${res.status}`;
      return { data: null, error: msg };
    }
    return { data: parsed as T, error: null };
  } catch (err) {
    return { data: null, error: err instanceof Error ? err.message : "network error" };
  }
}